import type { InferenceParams } from "@domain/agentic-environment/inference/params"
import type { RequestValidationRule } from "./rule"
import type { ModelName, ModelSpecification } from "../generative-model"

export class ReasoningEffortValidation implements RequestValidationRule {
	readonly name = "reasoning-effort"

	isValid(inferenceParams: InferenceParams<ModelName>, model: ModelSpecification): boolean {
		if (inferenceParams.reasoningEffort === undefined) {
			return true
		}

		if (!model.supportsReasoningEffort) {
			return false
		}

		return model.supportedReasoningEfforts.includes(inferenceParams.reasoningEffort)
	}
}
